import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, PRICE } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const closing = document.getElementById('cierre');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const closingTop = closing ? closing.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      const pastHero = heroBottom < 0;
      const atClosing = closingTop < window.innerHeight * 0.9;
      setVisible(pastHero && !atClosing);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-57" data-mp="33inxbgjistq6">
      {visible}
    </AnimatePresence>;
}